import { render, staticRenderFns } from "./TableAiAgent.vue?vue&type=template&id=ec97f5d2&scoped=true"
import script from "./TableAiAgent.vue?vue&type=script&lang=js"
export * from "./TableAiAgent.vue?vue&type=script&lang=js"
import style0 from "./TableAiAgent.vue?vue&type=style&index=0&id=ec97f5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec97f5d2",
  null
  
)

export default component.exports